
"use client";

import BaseModal from "../common/BaseModal";
import TextInput from "../input/TextInput";
import React, {useContext, useEffect, useState} from "react";
import DefaultButton from "../buttons/DefaultButton";
import {useAuth} from "../../providers/authProvider";
import {ApiContext} from "../contexts/ApiContext";
import {ValidationContext} from "../contexts/ValidationContext";
import CheckBoxInput from "../input/CheckBoxInput";
import SelectInput from "../input/SelectInput";
import TextArea from "../input/TextArea";

function EditHomeVisitModal(
    props: {
        openModal: boolean,
        setOpenModal: (arg: boolean) => void,
        visitInfo: any,
    }
) {
    const { token } = useAuth();
    const { Url } = useContext(ApiContext)
    const [Email, setEmail] = useState('')
    const [VisitDate, setVisitDate] = useState('')
    const [StartTime, setStartTime] = useState('')
    const [StartTimeSlot, setStartTimeSlot] = useState('')
    const [EndTimeSlot, setEndTimeSlot] = useState('')
    const [Planned, setPlanned] = useState(false)
    const [Address, setAddress] = useState('')
    const [ZipCode, setZipCode] = useState('')
    const [City, setCity] = useState('')
    const [Locked, setLocked] = useState(false)
    const [Payed, setPayed] = useState(false)
    const [Team, setTeam] = useState('')
    const [PresentLocation, setPresentLocation] = useState('')
    const [message, setMessage] = useState('')
    const [HomeVisitCategoryID, setHomeVisitCategoryID] = useState<number | string>(1)
    const [homeVisitCategories, setHomeVisitCategories] = useState<any[]>([])
    const [Comments, setComments] = useState('')
    const [CommentsRequest, setCommentsRequest] = useState('')
    const [Sprinkle, setSprinkle	] = useState('')


    const {nameRegex, nameErrorMessage} = useContext(ValidationContext)
    useEffect(() =>{
            //set all information in de modal
            if (!props.visitInfo) return;
            setEmail(props.visitInfo.Email)
            setVisitDate(props.visitInfo.DateISO)
            setStartTime(props.visitInfo.StartTime)
            setStartTimeSlot(props.visitInfo.StartTimeSlot)
            setEndTimeSlot(props.visitInfo.EndTimeSlot)
            setPlanned(props.visitInfo.Planned)
            setAddress(props.visitInfo.Address)
            setZipCode(props.visitInfo.ZipCode)
            setCity(props.visitInfo.City)
            setLocked(props.visitInfo.Locked)
            setPayed(props.visitInfo.Payed)
            setTeam(props.visitInfo.Team)
            setPresentLocation(props.visitInfo.PresentLocation)
            setHomeVisitCategoryID(props.visitInfo.HomeVisitCategoryID)
            setComments(props.visitInfo.Comments)
            setCommentsRequest(props.visitInfo.CommentsRequest)
            setSprinkle(props.visitInfo.Sprinkle)

        }, [props.visitInfo]
    )
    useEffect(() => {
        if (token) {
            try{

                fetch(Url + 'admin/home-visit-categories', {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': "Bearer " + token,
                    },
                })
                    .then((res) => {
                        if (res.status === 200) {

                            return res.json()
                        }else{
                            return [{
                                "message": "Geen Huisbezoek categorieen"
                            }]
                        }
                    })
                    .then((data) => {
                        setHomeVisitCategories(data)
                    })
            }catch (error){
                console.error("Laden niet gelukt.", error);
            }
        }
    }, [token, Url]);
    function editHomeVisit(event: React.FormEvent) {
        event.preventDefault()
        fetch(Url + 'admin/home-visits', {
            method: 'PATCH',
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + token,
            },
            body: JSON.stringify({
                ID: props.visitInfo.ID,
                Date: VisitDate,
                StartTime: StartTime,
                StartTimeSlot: StartTimeSlot,
                EndTimeSlot: EndTimeSlot,
                Planned: Planned,
                Locked: Locked,
                Address: Address,
                City: City,
                ZipCode: ZipCode,
                Email: Email,
                HomeVisitCategoryID: Number(HomeVisitCategoryID),
                Payed: Payed,
                Team: Team.toUpperCase(),
                PresentLocation: PresentLocation,
                Sprinkle: Sprinkle,
                Comments: Comments,
                CommentsRequest: CommentsRequest,
            }),
        })
            .then((res) => {
                if (res.status === 200) {
                    props.setOpenModal(false)
                }
                return res.json()
            })
            .then((data) => {
                setMessage('')
            })
    }

    return (
        <BaseModal
            show={props.openModal}
            onClose={() => props.setOpenModal(false)}
            title="Bewerk huisbezoek"
            footer={
                <>
                    <DefaultButton onClick={editHomeVisit} content="Wijzigen"/>
                    <DefaultButton onClick={() => props.setOpenModal(false)} content="Sluiten"/>
                </>
            }
        >
            <p className="text-base leading-relaxed text-gray-500">
                Geef de gegevens van het huisbezoek op en klik op toevoegen. Het mailadres moet van een bestaande
                gebruiker zijn. Bestaat deze gebruiker nog niet? Voeg dan eerst een nieuwe gebruiker toe.
            </p>
            <p className="text-base leading-relaxed text-red-500">
                {message}
            </p>
            <TextInput
                labelName="Email adres van de klant*"
                inputName="email"
                onChange={(e) => setEmail(e.target.value)}
                value={Email}
                placeholder="Email"
                errorMessage="Vul hier een geldig email in"
                pattern={undefined}
                type="email"
            />
            <p>Selecteer het type optreden</p>
            <SelectInput labelName="Type optreden*"
                         inputName="HomeVisitCategoryID"
                         onChange={(e) => setHomeVisitCategoryID(e.target.value)}
                         value={HomeVisitCategoryID}
                         errorMessage="Selecteer een van de opties uit de lijst"
                         options={homeVisitCategories}
            />
            <TextInput
                labelName="Bezoekdatum*"
                inputName="visitDate"
                value={VisitDate}
                placeholder="05/12/2024"
                errorMessage="Vul hier geldig datum in"
                pattern={undefined}
                type="date"
                onChange={(e) => setVisitDate(e.target.value)}
            />
            <TextInput
                labelName="Definitieve aankomsttijd"
                inputName="startTime"
                onChange={(e) => setStartTime(e.target.value)}
                value={StartTime}
                placeholder="13:00"
                errorMessage="Vul hier een geldig tijdstip in"
                pattern={undefined}
                type="time"
            />
            <TextInput
                labelName="Begin aankomsttijdsslot"
                inputName="startTimeSlot"
                onChange={(e) => setStartTimeSlot(e.target.value)}
                value={StartTimeSlot}
                placeholder="13:00"
                errorMessage="Vul hier een geldig tijdstip in"
                pattern={undefined}
                type="time"
            />
            <TextInput
                labelName="Einde aankomsttijdsslot"
                inputName="EndTimeSlot"
                onChange={(e) => setEndTimeSlot(e.target.value)}
                value={EndTimeSlot}
                placeholder="13:00"
                errorMessage="Vul hier een geldig tijdstip in"
                pattern={undefined}
                type="time"
            />
            <p>
                Op het moment dat een huisbezoek de status "Bevestigd" heeft ziet de klant het tijdstip welke is
                ingevulgd bij geplande starttijd. Op het moment dat het huisbezoek nog niet bevestigd is, ziet
                de klant een tijdblok waartussen de starttijd zich kan bevinden.
            </p>
            <CheckBoxInput labelName="Tijdstip bevestigd" inputName="planned" value="yes" checked={Planned}
                           setChecked={setPlanned} />
            <TextInput
                labelName="Adres*"
                inputName="adres"
                onChange={(e) => setAddress(e.target.value)}
                value={Address}
                placeholder="Straat + Huisnummer"
                errorMessage={nameErrorMessage}
                pattern={nameRegex}
                type="text"
            />
            <TextInput
                labelName="Postcode*"
                inputName="postcode"
                onChange={(e) => setZipCode(e.target.value)}
                value={ZipCode}
                placeholder="1234AA"
                errorMessage="Vul hier de postcode zonder spatie in"
                pattern="[0-9a-zA-Z ]{6,6}"
                type="text"
            />
            <TextInput
                labelName="Plaats*"
                inputName="city"
                onChange={(e) => setCity(e.target.value)}
                value={City}
                placeholder="Plaats"
                errorMessage={nameErrorMessage}
                pattern={nameRegex}
                type="text"
            />
            <SelectInput labelName="Strooien"
                         inputName="Sprinkle"
                         onChange={(e) => setSprinkle(e.target.value)}
                         value={Sprinkle}
                         errorMessage="Selecteer een van de opties uit de lijst"
                         options={
                             [
                                 {
                                     ID: "Ja zeker!",
                                     Name: "Ja zeker!"
                                 },
                                 {
                                     ID: "Ja, maar met mate",
                                     Name: "Ja, maar met mate"
                                 },
                                 {
                                     ID: "Nee, liever niet",
                                     Name: "Nee, liever niet"
                                 },
                             ]
                         }
            />
            <TextArea
                labelName="Locatie van de cadeau's."
                inputName="presentLocation"
                onChange={(e) => setPresentLocation(e.target.value)}
                value={PresentLocation}
                placeholder="In de schuur"
                rows={3}/>
            <TextArea
                labelName="Bijzonderheden"
                inputName="comments"
                onChange={(e) => setComments(e.target.value)}
                value={Comments}
                placeholder=""
                rows={3}/>
            <TextArea
                labelName="Opmerkingen bij de aanvraag"
                inputName="commentsRequest"
                onChange={(e) => setCommentsRequest(e.target.value)}
                value={CommentsRequest}
                placeholder=""
                rows={3}/>
            <TextInput
                labelName="Team"
                inputName="team"
                onChange={(e) => setTeam(e.target.value)}
                value={Team}
                placeholder="30A"
                errorMessage={nameErrorMessage}
                pattern={nameRegex}
                type="text"
            />
            <p>
                Op het moment dat een huisbezoek de status "Locked" heeft kan er niks meer door klant gewijzigd
                worden. Dit doe je alleen vlak voor het moment dat je het grote boek gaat exporten.
            </p>
            <CheckBoxInput labelName="Locked" inputName="locked" value="yes" checked={Locked}
                           setChecked={setLocked}/>
            <p>
                Hier kan je aangegeven of de factuur van de klant betaalt is.
            </p>
            <CheckBoxInput labelName="Factuur betaalt" inputName="payed" value="yes" checked={Payed}
                           setChecked={setPayed}/>
        </BaseModal>
    )
}
export default EditHomeVisitModal
